// extracted by mini-css-extract-plugin
export var addresses = "footer-module--addresses--keff8";
export var banner = "footer-module--banner--2oBZx";
export var footer = "footer-module--footer--QmYBy";
export var info = "footer-module--info--n68M7";
export var label = "footer-module--label--kz4qa";
export var legal = "footer-module--legal--fzete";
export var logo = "footer-module--logo--Cv2WD";